module.exports = __webpack_public_path__ + "static/media/dere.70ebcc49.png";